import { Box } from "@chakra-ui/react";
import { FormControlV2 } from "components";
import { FormControlsTypeEnum } from "enums/form-controls-type.enum";
import { FC } from "react";
import { Control, useWatch } from "react-hook-form";
import { REAPIT_SYNC_NOTES_MAX_LENGTH } from "utils/reapit.utils";
import { TReapitSyncFormFieldValues as TFieldValues } from "../reapit-sync-form-field.type";

interface IProps {
  control: Control<TFieldValues>;
}

export const NotesForm: FC<IProps> = ({ control }) => {
  const notes = useWatch({ control, name: "notes" }) ?? "";
  const isAtLimit = notes.length >= REAPIT_SYNC_NOTES_MAX_LENGTH;

  return (
    <>
      <Box
        width={"full"}
        py={2}
        px={5}
        mt={2}
        mb={2}
        background={"leadpro.50"}
        fontSize={"sm"}
      >
        Notes
      </Box>
      <Box mb={5} px={4}>
        <FormControlV2<TFieldValues>
          name={"notes"}
          control={control}
          type={FormControlsTypeEnum.TEXTAREA}
          isOptional
          additionalProps={{
            placeholder: "Add a note for Reapit…",
            textAreaRows: 4,
            maxLength: REAPIT_SYNC_NOTES_MAX_LENGTH,
          }}
        />
        <Box
          mt={1}
          fontSize={"xs"}
          textAlign={"right"}
          color={isAtLimit ? "red.500" : "leadpro.500"}
          aria-live={"polite"}
          aria-atomic={true}
        >
          {notes.length}/{REAPIT_SYNC_NOTES_MAX_LENGTH}
        </Box>
      </Box>
    </>
  );
};
